import React from 'react';
import InputMask from "react-input-mask";

const TextField = ({label, type, id, onChange, onBlur, maskedInput, ...rest}) => {
    const {required} = rest;

    if (!maskedInput) {
        return (<div className="flex flex-col items-start w-full">
            <label htmlFor={id} className='form-label'><span
                className={`${required ? 'after:content-["*"] after:text-red-600/70' : ''}`}> {label} </span></label>
            <input type={type} id={id} className={`form-input`} onChange={onChange} onBlur={onBlur} {...rest}/>
        </div>)
    }
    return (<div className="flex flex-col items-start w-full">
        <label htmlFor={id} className='form-label'><span
            className={`${required ? 'after:content-["*"] after:text-red-600/70' : ''}`}> {label} </span></label>
        <InputMask mask="aaa-999999999-*" id={id} className={`form-input`} onChange={onChange} maskChar=""
                   onBlur={onBlur} {...rest}/>
    </div>)
}

export default TextField;